import React, {useState, useEffect, useContext} from 'react';
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";
import {useFetching} from "../../hooks/useFetching";
import ApiSeo from "../../services/Seo";
import {API_SEO} from "../../utils/consts";
import i18next from "i18next";
import {observer} from "mobx-react-lite";
// import generateLanguageURL from "../../utils/generateLanguageURL";
import {LanguageContext} from "../../App";

const Seo = ({page}) => {
    const location = useLocation();
    const [seo, setSeo] = useState();
    const [, setLanguageContext] = useContext(LanguageContext);

    const [FunctionApiSeo, isLoading] = useFetching(async () => {
        try {
            const response = await ApiSeo.getApiSeo(API_SEO, page);
            setSeo(response.data);
        } catch {
            console.error('getApiSeo')
        }
    });

    useEffect(() => {
        FunctionApiSeo();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!isLoading && seo) {
            setLanguageContext({
                'es': location.pathname,
                'en': location.pathname,
                'ru': location.pathname,
                'uk': location.pathname,
            });
        }
    }, [isLoading, seo, location.pathname, setLanguageContext]);

    return (
        <Helmet>
            <html lang={i18next.language} />
            <title>{seo?.seo_title ? seo?.seo_title : 'ChampionTM | Рішення для України'}</title>
            <meta property="og:title" content={seo?.seo_title ? seo?.seo_title : 'ChampionTM | Рішення для України'} />
            <meta name="keywords" content={seo?.seo_keywords ? seo?.seo_keywords : 'казино Україна, казино Україна чемпіон, гральний бізнес, гральний бізнес в Україні, гемблінг, гемблінг Україна, ігрові автомати, ігрові автомати чемпіон онлайн, гральні автомати, казино під ключ, рішення для України, казино в Україні'} />
            <meta name="description" content={seo?.seo_description ? seo?.seo_description : 'Готове комплексне рішення для грального бізнесу в Україні. Програмне та апаратне забезпечення, а також повна організація ігрового процесу у закладі.'} />
            <meta property="og:description" content={seo?.seo_description ? seo?.seo_description : 'Готове комплексне рішення для грального бізнесу в Україні. Програмне та апаратне забезпечення, а також повна організація ігрового процесу у закладі.'} />
            <meta property="og:image" content={seo?.seo_image ? seo?.seo_image : '/static/championtm_api/img/og_fb.jpg'}/>
            <meta property="og:url" content={window.location.href}/>
            {/*<link rel="alternate" hrefLang="es-ua"*/}
            {/*      href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "es")).replace('//', '/')}/>*/}
            {/*<link rel="alternate" hrefLang="en-ua"*/}
            {/*      href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "en")).replace('//', '/')}/>*/}
            {/*<link rel="alternate" hrefLang="ru-ua"*/}
            {/*      href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "ru")).replace('//', '/')}/>*/}
            {/*<link rel="alternate" hrefLang="uk-ua"*/}
            {/*      href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "uk")).replace('//', '/')}/>*/}
            {/*<link rel="alternate" hrefLang="x-default"*/}
            {/*      href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "uk")).replace('//', '/')}/>*/}
        </Helmet>
    );
};

export default observer(Seo);